// extracted by mini-css-extract-plugin
module.exports = {"pictureCell":"UsersTableColumns_pictureCell_Q0ztY","picture":"UsersTableColumns_picture_3v1Xh","youMark":"UsersTableColumns_youMark_2-igo","roles":"UsersTableColumns_roles_HS5PM"};